import {
  Component,
  computed,
  effect,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import {MatFormField, MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/core";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {MatSelect} from "@angular/material/select";
import {TranslatePipe} from "@ngx-translate/core";
import {EditObjectDialogData} from "../../edit-object-dialog-data";
import {SelectObjectType} from "../../edit-object-dialog/edit-object-dialog.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-consists-of-step1',
  imports: [
    MatFormField,
    MatOption,
    MatRadioButton,
    MatRadioGroup,
    MatSelect,
    TranslatePipe,
    MatInput,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './consists-of-step1.html',
  styleUrl: './consists-of-step1.scss',
})
export class ConsistsOfStep1 implements OnInit {
  data: InputSignal<EditObjectDialogData> = input();
  selectObjectTypes: InputSignal<SelectObjectType[]> = input();

  actionSelected: OutputEmitterRef<string> = output();
  objectTypeSelected: OutputEmitterRef<SelectObjectType> = output();
  targetCountSelected: OutputEmitterRef<number> = output();

  selectedAction: WritableSignal<string> = signal('new_object');
  selectedObjectType: WritableSignal<string> = signal('');
  numberOfCopies: WritableSignal<number> = signal(1);

  rootObjectType = computed<string>(() =>
    this.data().fieldParameters.sectionsContainer.rootObject.object_type);

  private initialized = false;

  ngOnInit() {
    this.initialized = true;
  }

  constructor() {
    effect(() => {
      if (this.initialized) {
        this.selectTargetCount();
        this.selectObjectType(this.findObjectTypeByValue(this.rootObjectType()));
      }
    });
  }

  selectAction(action: string) {
    if (action !== 'new_object') {
      for (const objectType of this.selectObjectTypes()) {
        if (objectType.name) {
          if (objectType.objectType === this.rootObjectType()) {
            this.selectObjectType(objectType);
          }
        }
      }
    }

    this.selectedAction.set(action);
    this.actionSelected.emit(action);
  }

  selectObjectType(objectType: SelectObjectType) {
    this.selectedObjectType.set(objectType.objectType);
    this.objectTypeSelected.emit(objectType);
  }

  selectTargetCount() {
    const copies = this.numberOfCopies();
    this.targetCountSelected.emit(copies >= 1 && copies <= 100 ? copies : null);
  }

  findObjectTypeByValue(value: string): SelectObjectType | undefined {
    return this.selectObjectTypes().find(objectType => objectType.objectType === value);
  }
}
